import { mapState } from 'vuex';
import Filelist from '@/components/common/fileupload/filelist/Filelist.vue'

export default {
  name: 'ClientContractCard',
  props: {
    clientApiId: String,
    contract: Object,
    title: String,
    includeRateInfo: Boolean,
    rateconfig: [Object, String]
  },
  data () {
    return {
      loadingDrns: []
    }
  },
  components: {
    Filelist
  },
  computed: {
    ...mapState(['config']),
    drnDocuments () {
      return this.ZPFormatHelper.getDrnReportOptions(this.contract);
    },
    getTitle () {
      if (this.title) {
        return this.title;
      }
      return '';
    },
    rateConfigData () {
      if (this.includeRateInfo && this.rateconfig) {
        return this.rateconfig
      }
      return {};
    },
    reportOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, false);
    }
  },
  methods: {
    getRateInfoClass (data) {
      if (data) {
        return 'error';
      }
      return 'valid';
    },
    getDrnPdf (pdfCode) {
      this.loadingDrns.push(pdfCode);
      const self = this;
      this.ApiRequest.request('client/single/' + this.clientApiId + '/contract/' + this.contract.id + '/drn-pdf/' + pdfCode, this.ApiRequest.REQUEST_DOWNLOAD, {}, function (response) {
        const idx = self.loadingDrns.indexOf(pdfCode);
        if (idx >= 0) {
          self.loadingDrns.splice(idx, 1);
        }
      });
    },
    getReportName (val) {
      const el = this.reportOptions.find(el => el.reportSubcode == val);
      if (el) {
        return el.text;
      }
      return '';
    }
  }
}
